// removed by extract-text-webpack-plugin
module.exports = {"stickyNav":"stickyNav--3Xwr-","isSticky":"isSticky--2u2lR","container":"container--1aI5J","title":"title--2GBV6","buttons":"buttons--3gxAI","btn":"btn--1d7ou"};